module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Regular.a5f80d61.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Regular.woff
// module id = 3317
// module chunks = 51